<template>
    <div>
        <div id="deeplink" v-if="!fromApp">
            <div class="row" v-if="os!=null">
                <div class="col-12" style="margin-top: 40%; padding: 30px;">
                    <center>
                        <h3>Загрузите приложение для {{os}} по кнопке</h3>
                    </center>
                </div>
            </div>
            <div class="col-xs-12" style="padding: 3px;">
                <div class="row">
                    <div class="col-12" style="margin-top: 20px;">
                        <center>
                            <a :href="href" class="btn btn-lg btn-info">Установить приложение</a>
                        </center>
                    </div>
                </div>
            </div>
            <div class="col-xs-12" style="padding: 3px;">
                <div class="row">
                    <div class="col-12" style="margin-top: 20px;">
                        <center>
                            <button class="btn btn-lg btn-danger" v-on:click="fromApp=1">Продолжить тут</button>
                        </center>
                    </div>
                </div>
            </div>
        </div>
        <div id="start" v-else>
        <div class="row" v-if="regNewDst">
            <div class="col-xs-12" style="margin-top: 20px;">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Регистрация нового поставщика</h4>
                        <p>{{message}}</p>
                    </div>
                    <div class="card-content">

                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-xs-12" style="margin-top: 20px;">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">А давайте зарегистрируемся</h4>
                        <p>{{message}}</p>
<!--                        <input class="form-control" v-model="inn" style="margin-top: 20px;" placeholder="ИНН"></input>-->
                        <input class="form-control" v-model="phone" :key="pch" style="margin-top: 20px;" placeholder="Телефон"></input>
<!--                        <input class="form-control" v-model="address" style="margin-top: 20px;" placeholder="Адрес"></input>-->
                        <input class="form-control" v-model="info" style="margin-top: 20px;" placeholder="Комментарий"></input>
                        <button class="btn btn-danger" @click="buttonsave()" :disabled="btnOff" style="margin-top: 20px;">Отправить</button>
                    </div>
                    <div class="card-content">

                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>

  function getMobileOperatingSystem () {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera

    if (/android/i.test(userAgent)) {
      return 'Android'
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS'
    }

    return 'unknown'
  }

  function uuidv4 () {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    )
  }

  function checkparam (t) {
    if (t.$route.query.id === undefined) {
      return alert('не указан id')
    }
    if (t.$route.query.rc === undefined) {
      return alert('не указан rcode')
    }
  }

  export default {
    name: 'start',
    data () {
      return {
        regNewDst: false,
        resp: {},
        inn: '',
        phone: '',
        address: uuidv4(),
        info: '',
        message: '',
        dst: '',
        settings: undefined,
        btnOff: false,
        pch: 0,
        fromApp: 0,
        os: null,
        href: '#'
      }
    },
    mounted () {
      if (this.$route.query.app === '1') {
        this.fromApp = this.$route.query.app
      }

      this.$db.settings.toArray()
      // eslint-disable-next-line no-return-assign
        .then((x) => {
          if (x.length === 0) {
            this.os = getMobileOperatingSystem()
            if (this.$route.query.app !== '1') {
              this.setHref()
            }
          } else {
            this.fromApp = 1
          }
        })
      if (localStorage.getItem('phone') !== null) {
        this.phone = localStorage.getItem('phone')
        this.pch = 1
      }
    },
    methods: {
      setHref () {
        if (this.fromApp === 0) {
          if (this.os === 'iOS') {
            window.location = 'aki-webzakaz://https://1.aki1.ru/#/?id=' + this.$route.query.id + '&rc=' + this.$route.query.rc + '&client=' + this.$route.query.client + '&magazin=' + this.$route.query.magazin + '&contract=' + this.$route.query.contract + '&firm=' + this.$route.query.firm + '&stock=' + this.$route.query.stock + '&pricelist=' + this.$route.query.pricelist + '&agent=' + this.$route.query.agent + '&assortment=' + this.$route.query.assortment + '&inn=' + this.$route.query.inn + '&phone=' + this.$route.query.phone + '&address=' + this.$route.query.address
            this.href = 'https://apps.apple.com/ru/app/id1482629784'
          }
          if (this.os === 'Android') {
            // window.location = 'https://1.aki1.ru/#/?id=' + this.$route.query.id + '&rc=' + this.$route.query.rc + '&client=' + this.$route.query.client + '&magazin=' + this.$route.query.magazin + '&contract=' + this.$route.query.contract + '&firm=' + this.$route.query.firm + '&stock=' + this.$route.query.stock + '&pricelist=' + this.$route.query.pricelist + '&agent=' + this.$route.query.agent + '&assortment=' + this.$route.query.assortment + '&inn=' + this.$route.query.inn + '&phone=' + this.$route.query.phone + '&address=' + this.$route.query.address
            window.location = 'aki-webzakaz://https://1.aki1.ru/#/?id=' + this.$route.query.id + '&rc=' + this.$route.query.rc + '&client=' + this.$route.query.client + '&magazin=' + this.$route.query.magazin + '&contract=' + this.$route.query.contract + '&firm=' + this.$route.query.firm + '&stock=' + this.$route.query.stock + '&pricelist=' + this.$route.query.pricelist + '&agent=' + this.$route.query.agent + '&assortment=' + this.$route.query.assortment + '&inn=' + this.$route.query.inn + '&phone=' + this.$route.query.phone + '&address=' + this.$route.query.address
            this.href = 'https://play.google.com/store/apps/details?id=com.akitorg.provider'
          }
        }
      },
      notification (type, text, icon) {
        if (icon === '') {
          icon = 'ti-email'
        }
        this.$notify({
          component: {
            template: text
          },
          icon: 'ti-email',
          horizontalAlign: 'right', // right | center | left
          verticalAlign: 'top', // top | bottom
          type: type  // info | success | warning | danger
        })
      },
      sleep (ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms)
        })
      },
      saveSettings () {
        let uuid = uuidv4()
        // localStorage.curentDist = this.$route.query.id
        // this.$db.distributors.put({name: 'Sanya', token: uuid, dbase: this.$route.query.id, regcode: this.$route.query.rc})
        this.$db.settings.put({curentdst: 0, token: uuid, dbase: this.$route.query.id, regcode: this.$route.query.rc, lastconnection: Date.now(), inn: this.inn, phone: this.phone, address: this.address, info: this.info, сurent_dst: this.$route.query.id})
          .then((r) => {
            localStorage.curentDist = this.$route.query.id
            this.registration(uuid)
          })
          .catch((e) => {
            this.message = 'eп' + e
            console.log(e)
          })
      },
      buttonsave () {
        this.btnOff = true
        let _this = this
        // проверим есть ли такой дистрибутор по коду
        this.$db.distributors.toArray()
          .then((x) => {
            if (x.length !== 0) {
              let dbExist = 0
              for (let i = 0; i < x.length; i++) {
                if (x[i].dbase === _this.$route.query.id) {
                  this.$db.distributors.where('dbase').equals(_this.$route.query.id).delete()
                }
                if (x[i].dbase === '1389') {
                  this.$db.distributors.where('dbase').equals('1389').delete()
                }
                if (x[i].dbase === 1389) {
                  this.$db.distributors.where('dbase').equals(1389).delete()
                }
              }
              // если база не найдена
              if (dbExist !== 1) {
                this.saveSettings()
              } else {
                // eslint-disable-next-line no-return-assign
                _this.$router.push({ name: 'Obmen' })
              }
            } else {
              // eslint-disable-next-line no-return-assign
              _this.saveSettings()
            }
          })
          .catch((e) => {
            console.log(e)
            this.message = e
          })
      },
      checksettings () {
        this.$db.settings.toArray()
        // eslint-disable-next-line no-return-assign
          .then((x) => {
            if (x.length !== 0) {
              // this.$router.push({ name: 'Obmen' })
            } else {
              checkparam(this)
            }
          })
          .catch((e) => {
            console.log(e)
            this.message = e
          })
          .catch((e) => {
            console.log(e)
            this.message = e
          })
      },
      registration (uuid) {
        localStorage.phone = this.phone
        let x = this.$db.settings.toArray()
        this.settings = x[0]
        const axios = require('axios')
        this.resp.inn = this.$route.query.inn
        this.resp.phone = this.phone
        this.resp.info = this.info
        this.resp.client = this.$route.query.client
        this.resp.magazin = this.$route.query.magazin
        this.resp.contract = this.$route.query.contract
        this.resp.firm = this.$route.query.firm
        this.resp.stock = this.$route.query.stock
        this.resp.pricelist = this.$route.query.pricelist
        this.resp.agent = this.$route.query.agent


        if (this.resp.assortment !== undefined) {
          this.resp.assortment = this.$route.query.assortment
        }
        this.notification('success', '<span>Начало регистрации</span>')
        let data = JSON.stringify(this.resp)
        axios({
          method: 'post',
          url: 'https://webzakaz.akitorg.ru/i.php',
          headers: {'X-User-Id': this.$route.query.id, 'X-Authorization': uuid, 'X-Route': 'reg_new'},
          data: data
        })
          .then((res) => {
            // console.log('then')
            console.log(res)
            if (res.status === 200) {
              this.notification('success', '<span>Зарегистрирован</span>')
              if (res.data.client_extid.length > 0) {
                // переход
                this.$db.settings.update(uuid, {client_extid: res.data.client_extid, firm_name: res.data.firm_name})
                this.$db.distributors.put({name: res.data.firm_name, token: uuid, dbase: this.$route.query.id, regcode: this.$route.query.rc})
                this.$router.push({ name: 'Obmen' })
              }
            }
          })
          .catch((error) => {
            localStorage.phone = ''
            this.btnOff = false
            this.notification('danger', '<span>Проблемка</span>')
            let er = '<span>' + error + '</span>'
            this.notification('danger', er)
            console.log(error)
            if (error.response) {
              if (error.response.data === '400 Invalid phone') {
                console.log('не верный телефон')
                this.notification('warning', '<span>не верный телефон</span>')
                // alert('не верный телефон')
              }
              // if (error.response.data === '400 Invalid INN') {
              //   console.log('не верный ИНН')
              //   alert('не верный ИНН')
              // }
              if (error.response.data === '411 Array Required') {
                console.log('не верный телефон')
                alert('не верный телефон')
              }
              // if (error.response.data === '400 INN not found') {
              //   console.log('не верный INN')
              //   alert('не верный INN')
              // }
              if (error.response.data === '400 Uuid already registered') {
                console.log('Что то с UUID')
                alert('Что то с UUID')
              }
              if (error.response.data === '401 User Not Found') {
                console.log('401 User Not Found')
                alert('401 User Not Found')
              }
            } else if (error.request) {
              // The request was made but no response was received
              console.log(error.request)
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message)
            }
          })
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/UIComponents/Custom/Start.vue